import { c as _c } from "react/compiler-runtime";
// Gift OG shell — legacy MOR-392-era Figma Design-system node 477:1027.
// Visual provenance only; do not import from that file. Blue halftone + bottom
// wash, centered wordmark, bottom-centered `morfi.markets`.

import type { ReactNode } from 'react';
import { OG_DIMENSIONS, OG_TOKENS } from '../../tokens';
import { OgCelebrationOverlay } from '../chrome/og-celebration-overlay';
import { OgDemoModeBadge } from '../chrome/og-demo-mode-badge';
import { OgFooter } from '../chrome/og-footer';
import { OgLogo } from '../chrome/og-logo';
import { OgShellBackground } from '../chrome/og-shell-background';
import { OgShellSlot } from '../chrome/og-shell-slot';
import { SHELL_METRICS } from '../shell-tokens';
interface VariantProps {
  children: ReactNode;
  demoMode?: boolean;
}
export function ShellGift(props) {
  const $ = _c(13);
  const m = SHELL_METRICS.gift;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: OG_DIMENSIONS.width,
      height: OG_DIMENSIONS.height,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      padding: m.inset,
      gap: m.contentGap,
      color: OG_TOKENS.gray50,
      fontFamily: "Geist, var(--font-geist-sans), system-ui, sans-serif",
      overflow: "hidden"
    };
    t1 = <OgShellBackground variant="gift" />;
    t2 = <OgCelebrationOverlay />;
    t3 = <div style={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
      flexShrink: 0,
      position: "relative",
      zIndex: 1
    }}><OgLogo size={m.logoSize} /></div>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      width: "100%",
      minHeight: 0
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.children) {
    t5 = <OgShellSlot padding={m.slotPadding}><div style={t4}>{props.children}</div></OgShellSlot>;
    $[5] = props.children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div style={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
      flexShrink: 0,
      position: "relative",
      zIndex: 1
    }}><OgFooter eyebrow={null} align="center" /></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props.demoMode) {
    t7 = props.demoMode === true && <OgDemoModeBadge />;
    $[8] = props.demoMode;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div style={t0}>{t1}{t2}{t3}{t5}{t6}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}